<template>
    <div class="otherbox">
        <!-- 关联被告信息 -->
        <div class="htit">
            <div class="h2">代理人信息</div>
            <div class="rt">
                <!-- <div style="background-color: #1d8bfe;color: #fff;border-radius: 4px;padding: 8px 12px;cursor: pointer;"
                    @click="editstepname">
                    <a-icon type="edit" :style="{ fontSize: '14px', color: '#fff' }" />
                    <span style="margin-left: 10px;">当前负责人：</span>
                    <span>{{ step_user_name }}</span>
                </div> -->
                <!-- <a-button type="primary" ghost icon="edit" @click='visibleShow("OtherType");'
                    v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:edit") && debInfo.is_clear != 1'>修改
                </a-button> -->
            </div>
        </div>
        <div class="agentbox">
            <div class="agent-step-container">
                <div class="step-level-1-container" style="width: 55%;">
                    <div class="step-level-1"
                        v-for="(item1, index1) in agentStepList.ss" :key="index1">
                        <label class="step-label level-1-label"><span class="diamond-content">{{ item1.label
                                }}</span></label>
                        <div class="arrow-container level-1-arrow" v-if="item1.list.length>0">
                            <span class="arrow"></span>
                        </div>
                        <div class="step-level-2-wrapper">
                            <div class="step-level-2" v-for="(item2, index2) in item1.list" :key="index2">
                                <label class="step-label level-2-label" :style="{ marginLeft: index2 == 0 ? '10px' : '' }">{{
                                    item2.label }}</label>
                                <div class="arrow-container level-2-arrow"  v-if="item2.list.length>0">
                                    <span class="arrow"></span>
                                </div>
                                <div class="step-level-3-wrapper">
                                    <div class="step-level-3" v-for="(item3, index3) in item2.list" :key="index3">
                                        <label class="step-label level-3-label" v-if="item3.name">{{ item3.name }}</label>
                                        <div class="arrow-container level-3-arrow" v-if="item3.name">
                                            <span class="arrow"></span>
                                        </div>
                                        <div class="mode-wrapper" :class="{ ml_20: item3.name }">
                                            <div class="mode-item">
                                                <label>代理人：</label>
                                                <span>{{ item3.uname }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分隔线 -->
                <div class="line"></div>
                <div class="step-level-card" style="width: 45%;">
                    <div class="step-level-1"
                        v-for="(item1, index1) in agentStepList.zz" :key="index1">
                        <label class="step-label level-1-label"><span class="diamond-content">{{ item1.label
                                }}</span></label>
                        <div class="arrow-container level-1-arrow" v-if="item1.list.length>0">
                            <span class="arrow"></span>
                        </div>
                        <div class="step-level-2-wrapper">
                            <div class="step-level-2" style="flex: 1;" v-for="(item2, index2) in item1.list" :key="index2">
                                <label class="step-label level-2-label" :style="{ marginLeft: index2 == 0 ? '10px' : '' }">{{
                                    item2.label }}</label>
                                <div class="arrow-container level-2-arrow"  v-if="item2.list.length>0">
                                    <span class="arrow"></span>
                                </div>
                                <div class="step-level-3-wrapper">
                                    <div class="step-level-3" v-for="(item3, index3) in item2.list" :key="index3">
                                        <label class="step-label level-3-label" v-if="item3.name">{{ item3.name }}</label>
                                        <div class="arrow-container level-3-arrow" v-if="item3.name">
                                            <span class="arrow"></span>
                                        </div>
                                        <div class="mode-wrapper" :class="{ ml_20: item3.name }">
                                            <div class="mode-item">
                                                <label>代理人：</label>
                                                <span>{{ item3.uname }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="paddingBox">
                <a-row type='flex' style="align-items: center;">
                    <a-col :span="3" style="margin-right: 20px;">
                        <div>当前负责人：
                            <span style="margin-right: 2px;">{{ step_user_name }}</span>
                            <a-icon type="form" :style="{ fontSize: '12px', color: '#1D8BFE' }" @click="editstepname" />
                        </div>
                    </a-col>
                    <a-col :span="3">
                        <label>诉讼代理模式：</label>
                        <span>{{ agent_model }}</span>
                    </a-col>
                    <a-col :span="4">
                        <div style="display: flex;align-items: center;">
                            <label>诉讼立案代理人：</label>
                            <div style="display: flex;flex-direction: column;gap: 5px;">
                                <div style="display: flex;flex-direction: column;gap: 5px;">
                                    <div v-if="i.agent">一审：{{ i.agent }}</div>
                                    <div>二审：张顾问</div>
                                    <div v-if="i.agent">再审：{{ i.agent }}</div>
                                </div>
                            </div>

                        </div>
                    </a-col>
                    <a-col :span='4'>
                        <div style="display: flex;align-items: center;">
                            <label>开庭代理人：</label>
                            <div style="display: flex;flex-direction: column;gap: 5px;">
                                <div>一审：陈文平；王淑萍</div>
                                <div>二审：刘涵；张顾问</div>
                                <div>再审：赵晓伟；陈文平</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span='3'>
                        <label>执行代理模式：</label>
                        <span>{{ agent_model }}</span>
                    </a-col>
                    <a-col :span='3'>
                        <div style="display: flex;align-items: center;">
                            <label>执行立案代理人：</label>
                            <div style="display: flex;flex-direction: column;gap: 5px;">
                                <div>王福平</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col>
                        <div style="display: flex;align-items: center;">
                            <label>执行代理人：</label>
                            <div style="display: flex;flex-direction: column;gap: 5px;">
                                <div>陈文平；王淑萍</div>
                                <div>刘涵；张顾问</div>
                                <div>赵晓伟；陈文平</div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div> -->
        </div>
        <div class="solids"></div>
        <drag-modal :visible="stepnameVisible" @cancel="close" title='更换负责人' width='330px'>
            <a-spin :spinning="loading">
                <div>
                    <label>当前负责人：</label>
                    <a-select style="min-width: 150px;margin-left: 10px;" size="small"
                        :value="step_user_id === 0 ? null : step_user_id" placeholder="当前负责人" class="nselect"
                        show-search @change="setStepUser($event, i)" :filter-option="filterOption">
                        <a-select-option v-for="i in userList" :key="i.id">{{ i.uname }}</a-select-option>
                    </a-select>
                </div>
                <div style="margin-top: 40px;">
                    <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消"
                        @confirm="confirm">
                        <a-button :disabled="disabledShow" type="primary" style="width:130px;">
                            提交
                        </a-button>
                    </a-popconfirm>
                    <a-button style="margin-left: 20px;width:130px;background:#B2C9E1;color:#fff;"
                        @click='close'>取消</a-button>
                </div>
            </a-spin>
        </drag-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { accUserList } from '@/server/user'
import { color } from 'echarts';
import { causeStStepUser } from '@/server/user'
export default {
    props: {
        i: Object,
        agent_model: String
    },
    name: 'Agent',
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY',
        ])
    },
    data() {
        return {
            userList: [],
            step_user_name: '',
            stepnameVisible: false,
            disabledShow: false,
            form: {},
            loading: false,
            datas: {},
            step_user_id: '',
            agentStepList: {
            ss:[
                {
                    label: '诉讼阶段',
                    list: [
                        {
                            label: '立案',
                            list: [
                                {
                                    name: '保全',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                },
                                {
                                    name: '一审',
                                    proxy_pattern: '员工代理',
                                    uname: '王先生，程先生',
                                    cost_pattern: '风险代理'
                                },
                                {
                                    name: '二审',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                },
                                {
                                    name: '再审',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                }
                            ]
                        },
                        {
                            label: '开庭',
                            list: [
                                {
                                    name: '一审',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                },
                                {
                                    name: '二审',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                },
                                {
                                    name: '再审',
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                }
                            ]
                        },
                    ]
                },
            ],
            zz:[
                {
                    label: '执行阶段',
                    list: [
                        {
                            label: '立案',
                            list: [
                                {
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                }
                            ]

                        },
                        {
                            label: '执行',
                            list: [
                                {
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                },
                                {
                                    proxy_pattern: '员工代理',
                                    uname: '张先生，李先生',
                                    cost_pattern: '固定收费'
                                },
                                // {
                                //     proxy_pattern: '律师代理',
                                //     uname: '程律师，李律师',
                                //     cost_pattern: '固定收费'
                                // },
                                // {
                                //     proxy_pattern: '律师代理',
                                //     uname: '张律师，万律师',
                                //     cost_pattern: '固定收费'
                                // },
                                // {
                                //     proxy_pattern: '员工代理',
                                //     uname: '王先生，赵先生',
                                //     cost_pattern: '固定收费'
                                // }
                            ]

                        },
                    ]
                },
                {
                    label: '公安侦查',
                    list: [
                        {
                            label: '诉讼',
                            list: [
                                {
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                }
                            ]

                        }
                    ]
                },
                {
                    label: '审判监督',
                    list: [
                        {
                            label: '审判',
                            list: [
                                {
                                    proxy_pattern: '律师代理',
                                    uname: '张律师，李律师',
                                    cost_pattern: '固定收费'
                                }
                            ]

                        }
                    ]
                }
            ]
            }
        }
    },
    created() {
        this.step_user_id = this.i.step_user_id
        accUserList({ is_inner: 1 }).then(e => {
            this.userList = e.all.inner
            this.userList.map(item => {
                if (item.id == this.i.step_user_id) {
                    this.step_user_name = item.uname
                }
            })
        })
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        visibleShow(name) {
            // console.log(this.debInfo);

            this.$store.dispatch("openkey", { key: name, by: true })

        },
        setStepUserone(value, item) {
            item.step_user_id = value || 0;
            causeStStepUser({ cause_id: item.id, user_id: item.step_user_id }).then(e => {
                this.$message.success({ content: '设置成功', key: 'updatable' });
            })
        },
        setStepUser(value, item) {
            this.step_user_id = value || 0
            this.datas = item
        },
        editstepname() {
            this.stepnameVisible = true
        },
        close() {
            this.stepnameVisible = false
        },
        confirm() {
            this.disabledShow = true
            causeStStepUser({ cause_id: this.datas.id, user_id: this.step_user_id }).then(e => {
                this.$message.success({ content: '设置成功', key: 'updatable' });
                this.userList.map(item => {
                    if (item.id == this.step_user_id) {
                        this.step_user_name = item.uname
                    }
                })
                this.stepnameVisible = false
                this.disabledShow = false
            })
        },

    }
}
</script>
<style scoped>
.mindmap-flow {
    padding: 20px;
}

.node {
    margin: 8px 0;
    padding-left: 20px;
    position: relative;
}

/* .node::before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 12px;
  height: 1px;
  background: #1d8bfe;
} */
.children {
    margin-top: 4px;
}

.agentbox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 0 0;
    box-sizing: border-box;
}

/* 整体容器：统一字体和间距 */
.agent-step-container {
    width: 99%;
    display: flex;
    align-items: center; /* 修改为flex-start，让内容从顶部开始 */
    justify-content: space-between; /* 修改为space-between，确保左右区域紧贴分隔线 */
    font-size: 0.875rem;
    color: #333;
    background-color: #6bb1fc15;
    position: relative; /* 添加相对定位，作为分隔线的定位参考 */
    min-height: 100px; /* 设置最小高度，避免内容为空时分隔线消失 */
}

/* ss区域容器 */
.step-level-1-container {
    padding-right: 20px; /* 给分隔线留出空间 */
}

/* 通用标签样式 */
.step-label {
    white-space: nowrap;
    font-weight: 500;
}

/* 通用箭头样式：绝对定位 + 居中 */
.arrow {
    position: absolute;
    content: "";
    width: 20px;
    height: 20px;
    margin-top: -10px;
    background: url("../../../assets/img/arrow.png") no-repeat center;
    background-size: contain;
}

/* 分隔线样式：绝对定位 + 垂直贯穿 */
.line{
    width: 8px;
    background-color: #ffffff; /* 改为白色 */
    position: absolute; /* 绝对定位 */
    left: 55%; /* 定位到ss区域（55%）的右侧 */
    top: 0; /* 顶部对齐 */
    bottom: 0; /* 底部对齐，实现高度自适应 */
    transform: translateX(-50%); /* 居中对齐到55%的位置 */
    z-index: 1; /* 确保分隔线在内容上方 */
   
}

/* ---------------- 一级节点样式 ---------------- */
.step-level-card{
    /* display: flex;
    flex-wrap: wrap; */
    padding-left: 20px; /* 给分隔线留出空间 */
}
.step-level-1 {
    display: flex;
    align-items: center;
    /* 一级节点整体垂直居中 */
    margin-bottom: 0px;
    /* 一级节点之间的间距 */
    position: relative;
    padding: 20px;
    /* border-right: 1px solid #1d8bfe; */
}

/* 一级标签容器：相对定位，用于箭头定位 */
.level-1-label-wrap {
    position: relative;
    padding-right: 30px;
    /* 给箭头留出空间 */
    height: 100%;
    display: flex;
    align-items: center;
}

.level-1-label {
    font-size: 15px;
    background-color: #1d8bfe;
    color: #fff;
    /* color: #1d8bfe; */
    /* border: 1px solid #1d8bfe; */
    border-radius: 50%;
    padding: 8px 12px;
}

.diamond {
    width: 120px;
    height: 55px;
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
    background: linear-gradient(135deg, #1d8bfe 0%, #0078ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 8px rgba(29, 139, 254, 0.2);
}

/* 一级箭头：指向二级节点，自动斜向分布 */
.level-1-arrow {
    margin-left: 5px;
}

/* 二级节点容器：纵向排列 + 居中对齐 */
.step-level-2-wrapper {
    display: flex;
    flex-wrap: wrap;
    /* flex-direction: column; */
    gap: 20px;
    /* 二级节点（立案/开庭）之间的间距，影响箭头角度 */
}

/* ---------------- 二级节点样式 ---------------- */
.step-level-2 {
    display: flex;
    align-items: center;
    /* 二级节点整体垂直居中 */
    position: relative;
    margin-left: 20px;
}

.level-2-label-wrap {
    position: relative;
    padding-right: 30px;
    display: flex;
    align-items: center;
}

.level-2-label {
    font-size: 0.875rem;
    background-color: #1d8bfe;
    color: #fff;
    /* color: #1d8bfe; */
    /* border: 1px solid #1d8bfe; */
    border-radius: 4px;
    padding: 0 6px;
}

.level-2-arrow {
    margin-left: 10px;
}

/* 三级节点容器：纵向排列 + 居中对齐 */
.step-level-3-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* 三级节点（保全/一审）之间的间距 */
    margin-left: 10px;
}

/* ---------------- 三级节点样式 ---------------- */
.step-level-3 {
    display: flex;
    align-items: center;
    /* 三级节点整体垂直居中 */
    gap: 8px;
    /* 标签、箭头、内容之间的间距 */
    margin-left: 20px;
}

.level-3-label {
    font-size: 0.875rem;
    background-color: #1d8bfe;
    color: #fff;
    /* color: #1d8bfe; */
    /* border: 1px solid #1d8bfe; */
    border-radius: 4px;
    padding: 0 6px;
}

/* 三级箭头：横向指向代理模式 */
.level-3-arrow {
    position: static;
    /* 取消绝对定位，跟随布局 */
    margin: 0 5px;
}

/* ---------------- 代理/费用模式容器 ---------------- */
.mode-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
}

.ml_20 {
    margin-left: 20px;
}

.mode-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.mode-item label {
    white-space: nowrap;
    color: #666;
}

.mode-item span {
    color: #333;
}

/* ---------------- 响应式适配 ---------------- */
@media (max-width: 992px) {
    .agent-step-container {
        padding: 20px;
    }

    .step-level-2-wrapper {
        gap: 30px;
    }

    .step-level-3-wrapper {
        gap: 15px;
    }
    
    /* 响应式下调整分隔线位置 */
    .line {
        left: 50%;
    }
    
    .step-level-1-container, .step-level-card {
        width: 48% !important;
    }
}
</style>